import { actionCreatorFactory } from "typescript-fsa";

import { Activity } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

const factory = actionCreatorFactory("MODULF");

export const updateIntegratedDocument = factory<UpdateIntegratedDocumentPayload>("UPDATE_INTEGRATED_DOCUMENT");

export interface UpdateIntegratedDocumentPayload {
	readonly processId: string;
	readonly subdocumentId: string;
	readonly subdocument: Partial<Activity.Data.Document>;
	readonly mode?: "override" | "merge";
}
